import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { GoogleDistancePipe } from '../../../pipe/google/google-distance.pipe';

/**
 * @Deprecated:: Use `GmapsViewDirectionsResult` from `@infodata-group/inf-commons-tools` instead.
 */
@Component({
  selector: 'infl-view-google-directions-result',
  imports: [TranslatePipe, GoogleDistancePipe],
  templateUrl: './view-google-directions-result.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './view-google-directions-result.component.scss',
})
export class ViewGoogleDirectionsResultComponent {
  public iconStart = input.required<string>();
  public directionsResult = input.required<google.maps.DirectionsResult>();

  protected directionsLeg = computed(() => {
    if (!this.directionsResult()) {
      return null;
    }
    if (this.directionsResult().routes.length === 0) {
      return null;
    }
    return this.directionsResult().routes[0].legs[0];
  });

  protected steps = computed(() => {
    if (!this.directionsLeg()) {
      return [];
    }
    return this.directionsLeg().steps || [];
  });

  public totalDistance = computed(() => {
    if (!this.directionsLeg()) {
      return '';
    }
    return this.directionsLeg().distance?.text || '';
  });

  public totalDuration = computed(() => {
    if (!this.directionsLeg()) {
      return '';
    }
    return this.directionsLeg().duration?.text || '';
  });
}
